import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ControllerProps } from 'src/router';
import { ObjectUtils } from 'src/core/utils/object';
import { MarketFormView } from './market-form.view';
import { MarketDataService } from './market-form.data';
import { CurrencyListDataService } from 'src/app/general/currencies/list/currency-list.data';
import { ConfigurationService } from 'src/core/services/configuration.service';

interface MarketFormParams {
    id: string;
    type: string;
}

@observer
export class MarketFormController extends React.Component<ControllerProps<MarketFormParams>, any> {
    @observable
    protected dataService: MarketDataService;

    @resolve
    protected toast: ToastNotifications;

    @observable
    mode: ControlMode = 'display';

    protected currencyDataService: CurrencyListDataService;

    @observable
    protected currencies: CurrencySummary[];

    @resolve
    protected configurationService: ConfigurationService;

    @observable
    defaultLanguaje: string;

    constructor(props) {
		super(props);
		this.dataService = MarketDataService.make();
        this.currencyDataService = CurrencyListDataService.make();
    }

    @computed
    protected get title() {
		if (this.dataService && this.dataService.item && this.dataService.item.name) {
			return `Market ${this.dataService.item.name}`;
		}
		else {
			return 'New Market';
		}
    }

    @autobind
    protected onModeChanged(mode: ControlMode) {
        this.mode = mode;
    }

    @autobind
	protected create() {
		const place: any = this.dataService.add(this.defaultLanguaje);
        return place;
    }

    @autobind
    public async save() {
        const item = this.dataService.item;
        const errors = await item.validate(true);
        if (errors.length == 0) {
            this.props.setBusy(true);

            this.dataService.save()
                .then(() => {
                    this.props.setBusy(false);
                    this.onModeChanged('display');
                    this.toast.showDataSaved();
                    this.props.history.replace(`/general/market`);
                })
                .catch((error) => {
                    this.props.setBusy(false);
                    this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
                });
        } else {
            this.toast.showToast('Validation error!', errors.map(e => e.text), 'error');
        }
    }

    @autobind
	public cancel() {
		this.props.history.push('/general/market');
    }

	componentDidMount() {
		this.props.setBusy(true);
		this.currencyDataService.addSorting('id', 'asc', true);
		this.currencyDataService.load(query => query)
			.then(res => {
				this.currencies = res.slice();
			});

		this.configurationService.current()
			.then(res => {
				let create = this.props.match.params.id == 'new';
				this.defaultLanguaje = res.defaultLanguage;
				if (create) {
					// Create new
					(this.dataService as any).create(this.create)
						.then(() => {
							this.mode = 'edit';
							this.props.setBusy(false);
						})
						.catch((error) => {
							this.props.setBusy(false);
							this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
						});
				} else {
					this.dataService.addFilter('id', 'eq', this.props.match.params.id);
					this.dataService.addSorting('id', 'asc', true);
					this.dataService.pageSize = 1;
					this.dataService.load(query => query)
						.catch((error) => {
							this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
						})
						.then(() => {
							this.props.setBusy(false);
						});
				}
			});
	}

    render() {
        if (this.dataService == null || this.dataService.item == null) {
            return null;
        }
        if (this.currencies == null) {
            return null;
        }

        return (
			<MarketFormView
				title={this.title}
				mode={this.mode}
				onModeChanged={this.onModeChanged}
				cancel={this.cancel}
				save={this.save}
				currencies={this.currencies.slice()}
				model={this.dataService}
				setBusy={this.props.setBusy}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/market/form/market-form.controller.tsx